import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './list.module.scss';
export const Li = ({ children, className })=>/*#__PURE__*/ _jsx("li", {
        className: classNames('li', styles.li, className),
        children: children
    });
export const Ul = ({ children, className })=>/*#__PURE__*/ _jsx("ul", {
        className: classNames('ul', styles.ul, className),
        children: children
    });
export const Ol = ({ children, className })=>/*#__PURE__*/ _jsx("ol", {
        className: classNames('ol', styles.ol, className),
        children: children
    });

//# sourceMappingURL=list.js.map